/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { IncidentEventDto } from './IncidentEventDto';
import type { UserDto } from './UserDto';

export type CollaborationToolDisconnectedIncidentEventDto = (IncidentEventDto & {
    createdByUser?: UserDto;
    itemKey?: string;
    itemType?: CollaborationToolDisconnectedIncidentEventDto.itemType;
    itemUrl?: string;
} & {
    itemKey: string;
    itemType: CollaborationToolDisconnectedIncidentEventDto.itemType;
});

export namespace CollaborationToolDisconnectedIncidentEventDto {

    export enum itemType {
        JIRA = 'JIRA',
        SERVICENOW = 'SERVICENOW',
    }


}
